 <template>
  <div class="htPage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入搜索关键词"
      show-action
      shape="round"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        finished-text="没有更多了"
      >
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell
              :title="`${projectItem.contractName}`"
              clickable
              v-for="projectItem in itemMainList"
              :key="projectItem.id"
              @click="selectitem(projectItem)"
            >
              <van-radio slot="right-icon" :name="`${projectItem.contractName}`" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker">取消</a>
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
export default {
  name: "projectView",
  data() {
    return {
      radio: "", //选中的项目
      searchName: "",
      searchKeyword: "", //搜索的项目合同
      total: "", //统计计算
      itemMainList: [],
      selecItemList: [],
      projectData: {},

      Itempage: 0,
      pageSize: 10,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      clientType: "" //手机类型
    };
  },

  mounted() {
    let winHeight = document.documentElement.clientHeight; //视口大小
    document.getElementById("list-content").style.height =
      winHeight - 95 + "px"; //调整上拉加载框高度
  },
  methods: {
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },

    getTest() {
      let _this = this;
      if (_this.Itempage != 0 && this.Itempage * 10 >= parseInt(_this.total)) {
        return;
      }
      _this.Itempage += 1;
      _this.$api.baseCommon.baseMsg.dictBox
        .commonContract({
          pageNum: _this.Itempage,
          pageSize: _this.pageSize,
          contractName: _this.searchName
        })
        .then(res => {
          if (res.code == "1") {
            _this.total = parseInt(res.data.total);

            _this.selecItemList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;
            if (_this.Itempage * 10 >= _this.total) {
              _this.finished = true;
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.itemMainList = this.itemMainList.concat(this.selecItemList);
    },
    selectitem(data) {
      let _this = this;
      _this.radio = data.contractName;
      _this.projectData = data;
    },
    closeRetinuePicker() {
      this.projectData = {};
      this.$emit("setReview", "");
    },
    saveRetinue() {
      let _this = this;
      this.$emit("setReview", _this.projectData);
      _this.projectData = new Object();
    },

    reloadPage() {
      this.Itempage = 0;
      this.total = 0;
      this.itemMainList = [];
      this.getTest();
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 300);
    }
  }
};
</script>
<style lang="less" >
.htPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-content {
    overflow: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    border-top: 1px solid #f6f6f6;
    bottom: 0;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>